
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useLayoutEffect } from 'react';

var index =  useLayoutEffect ;

export { index as default };
//# sourceMappingURL=use-isomorphic-layout-effect.browser.esm.js.map
